import liff from "@line/liff";

export const state = {
  isLiffClient: !!liff.isInClient(),
};

export const getters = {
  getGlobal(state) {
    return function(key) {
      return state[key]
    };
  },
};

export const mutations = {
  SET_GLOBAL(state, { key, data }) {
    if (key in state) {
      state[key] = data
    } else {
      console.log(`請先在state宣告 ${key}`)
    }
  },
};

export const actions = {
  setGlobal({ commit }, { key, data }) {
    console.log('setGlobal', key, data)
    return commit('SET_GLOBAL', { key, data });
  },
};
